// import debounce from 'lodash/debounce'
import { sortBy, map, isEqual } from 'lodash'
// import cloneDeep from 'lodash/cloneDeep'

// https://lodash.com/docs/4.17.15#debounce
export function debounceFunc(func, wait = 1000, options = {}) {
  let timeout = null
  return function (...args) {
    let context = this
    if (timeout) clearTimeout(timeout)
    // let isTime = !timeout
    // timeout = setTimeout(function () {
    //   timeout = null
    // }, wait)
    // if (isTime) func.apply(this, args)
    timeout = setTimeout(function () {
      func.apply(context, args)
    }, wait)
  }
}

// https://lodash.com/docs/4.17.15#sortBy
export function sortFunc(arr, func) {
  return sortBy(arr, func)
}

// https://lodash.com/docs/4.17.15#map
export function mapFunc(arr, func) {
  return map(arr, func)
}

// https://lodash.com/docs/4.17.15#isEqual
export function isEqualFunc(value, other) {
  return isEqual(value, other)
}

// https://lodash.com/docs/4.17.15#VocDeepClone.deepClone
export function deepCopy(data) {
  return cloneDeep(data)
}
